import React, { Suspense } from 'react';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
const ChatApp = React.lazy(() => import('chats/App')); // микрофронт чата https://gitlab.go-chat.ru/mrc/frontend-services/chat-frontend

export const ChatsPage = () => {
  return (
    <Suspense fallback="loading">
      <ChatApp />
    </Suspense>
  );
};
